export const FC_CTR_STR = [" FC CTR", " F/C CTR"];

export const marketHeadersData = [
  {
    id: 2,
    storeNbr: "756197",
    name: "market1",
  },
  {
    id: 3,
    storeNbr: "757972",
    name: "market2",
  },
  {
    id: 4,
    storeNbr: "755941",
    name: "market3",
  },
];

export const filterColumns = ["programId", "customerName", "description", "userId", "createdDate", "updatedDate"];

export const programSearchTableHeaders = [
  {
    id: 1,
    name: "Program ID",
    dataKey: "programId",
    sortable: true,
  },
  {
    id: 2,
    name: "Customer Name",
    dataKey: "customerName",
    sortable: true,
  },
  {
    id: 3,
    name: "Description",
    dataKey: "description",
    sortable: true,
  },
  {
    id: 4,
    name: "Created by",
    dataKey: "userId",
    sortable: true,
  },
  {
    id: 5,
    name: "Created Date",
    dataKey: "createdDate",
    sortable: true,
  },
  {
    id: 6,
    name: "Update Date",
    dataKey: "updatedDate",
    sortable: true,
  },
];

export const mobileProgramSearchTableHeaders = [
  {
    keyName: "Program ID",
    valueName: "programId",
    classNameOne: "m-b-16",
    classNameTwo: "customer-txt",
  },
  {
    keyName: "Customer Name",
    valueName: "customerName",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Description",
    valueName: "description",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Created by",
    valueName: "userId",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Created Date",
    valueName: "createdDate",
    classNameOne: "m-b-16",
  },
  {
    keyName: "Update Date",
    valueName: "updatedDate",
    classNameOne: "m-b-16",
  },
];

export const tempData = [
  {
    categoryId: 2,
    categoryName: "Glue Down Carpet",
    typeId: 1,
    subTotal: "Subtotal",
    products: [
      {
        categoryId: 2,
        typeId: 1,
        name: "prod name",
      },
    ],
    laborCodes: [
      {
        laborCodeId: 12,
        laborCode: "A20",
        laborCodeDescription: "INSTALL GLUE DOWN CARPET VACANT",
      },
      {
        laborCodeId: 41,
        laborCode: "C11",
        laborCodeDescription: "TAKE UP GLUE DOWN CARPET",
      },
    ],
  },
  {
    categoryId: 3,
    categoryName: "Carpet Tile",
    typeId: 1,
    subTotal: "Subtotal",
    products: [
      {
        categoryId: 3,
        typeId: 1,
        name: "prod name",
      },
    ],
    laborCodes: [
      {
        laborCodeId: 14,
        laborCode: "A22",
        laborCodeDescription: "INSTALL GLUE DOWN CARPET TILE VACANT",
      },
      {
        laborCodeId: 41,
        laborCode: "C11",
        laborCodeDescription: "TAKE UP GLUE DOWN CARPET",
      },
    ],
  },
  {
    categoryId: 4,
    categoryName: "Laminate",
    typeId: 2,
    subTotal: "Subtotal",
    products: [
      {
        categoryId: 4,
        typeId: 2,
        name: "prod name",
      },
    ],
    laborCodes: [
      {
        laborCodeId: 19,
        laborCode: "A50",
        laborCodeDescription: "INSTALL LAMINATE FLOOR",
      },
      {
        laborCodeId: 47,
        laborCode: "C35",
        laborCodeDescription: "REMOVE LAMINATE",
      },
    ],
  },
  {
    categoryId: 9,
    categoryName: "Wood",
    typeId: 2,
    subTotal: "Subtotal",
    products: [
      {
        categoryId: 9,
        typeId: 2,
        name: "prod name",
      },
    ],
    laborCodes: [
      {
        laborCodeId: 18,
        laborCode: "A40",
        laborCodeDescription: "INSTALL WOOD FLOOR",
      },
      {
        laborCodeId: 44,
        laborCode: "C30",
        laborCodeDescription: "REMOVE WOOD FLOOR",
      },
    ],
  },
];

export const pricesData = [
  {
    lineItemPriceId: 2,
    price: 1.25,
    marketId: 44,
    lineItemId: "144",
    createdBy: "emf696",
    createdTime: null,
    updatedBy: null,
    updatedTime: null,
  },
  {
    lineItemPriceId: 2,
    price: 1.1,
    marketId: 43,
    lineItemId: "144",
    createdBy: "emf696",
    createdTime: null,
    updatedBy: null,
    updatedTime: null,
  },
  {
    lineItemPriceId: 3,
    price: 0.8,
    marketId: 43,
    lineItemId: "145",
    createdBy: "emf696",
    createdTime: null,
    updatedBy: null,
    updatedTime: null,
  },
  {
    lineItemPriceId: 3,
    price: 0.9,
    marketId: 45,
    lineItemId: "145",
    createdBy: "emf696",
    createdTime: null,
    updatedBy: null,
    updatedTime: null,
  },
  {
    lineItemPriceId: 4,
    price: 0.5,
    marketId: 43,
    lineItemId: "146",
    createdBy: "emf696",
    createdTime: null,
    updatedBy: null,
    updatedTime: null,
  },
  {
    lineItemPriceId: 4,
    price: 0.5,
    marketId: 44,
    lineItemId: "146",
    createdBy: "emf696",
    createdTime: null,
    updatedBy: null,
    updatedTime: null,
  },
  {
    lineItemPriceId: 4,
    price: 0.5,
    marketId: 45,
    lineItemId: "146",
    createdBy: "emf696",
    createdTime: null,
    updatedBy: null,
    updatedTime: null,
  },
  {
    lineItemPriceId: 5,
    price: 0.2,
    marketId: 43,
    lineItemId: "197",
    createdBy: "emf696",
    createdTime: null,
    updatedBy: null,
    updatedTime: null,
  },
  {
    lineItemPriceId: 5,
    price: 0.2,
    marketId: 54,
    lineItemId: "197",
    createdBy: "emf696",
    createdTime: null,
    updatedBy: null,
    updatedTime: null,
  },
];
